export default [
  // v1
  // {
  //   path: '/:projectId/dashboard-v1',
  //   name: 'dashboard-v1',
  //   component: () => import('@/views/dashboard/Dashboard.vue'),
  //   meta: {
  //     projectRequired: true,
  //     pageTitle: 'Dashboard',
  //     breadcrumb: [
  //       { text: 'CDN', disabled: true },
  //       { text: 'Dashboard', active: true },
  //     ],
  //   },
  // },
  // v2
  {
    path: '/:projectId/analytics',
    component: () => import('@/views/cdn/dashboardV2/Dashboard.vue'),
    meta: {
      projectRequired: true,
      pageTitle: 'Analytics',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Analytics', active: true },
      ],
    },
    children: [
      {
        path: '',
        component: () => import('@/views/cdn/dashboardV2/tabs/Bandwidth.vue'),
        name: 'analytics',
        meta: {
          projectRequired: true,
          pageTitle: 'Analytics',
          parent: 'analytics',
          rule: 'admin',
          navActiveLink: 'analytics',
          noAnimation: true,
          breadcrumb: [
            { text: 'CDN', disabled: true },
            { text: 'Analytics', active: true },
            { text: 'Bandwidth', active: true },
          ],
        },
      },
      {
        path: 'traffic',
        component: () => import('@/views/cdn/dashboardV2/tabs/Traffic.vue'),
        name: 'traffic',
        meta: {
          projectRequired: true,
          pageTitle: 'Analytics',
          parent: 'analytics',
          rule: 'admin',
          navActiveLink: 'analytics',
          redirectTo: 'analytics',
          noAnimation: true,
          breadcrumb: [
            { text: 'CDN', disabled: true },
            { text: 'Analytics', to: { name: 'analytics' }, active: false },
            { text: 'Traffic', active: true },
          ],
        },
      },
      {
        path: 'requests',
        component: () => import('@/views/cdn/dashboardV2/tabs/Requests.vue'),
        name: 'requests',
        meta: {
          projectRequired: true,
          pageTitle: 'Analytics',
          parent: 'analytics',
          rule: 'admin',
          navActiveLink: 'analytics',
          redirectTo: 'analytics',
          noAnimation: true,
          breadcrumb: [
            { text: 'CDN', disabled: true },
            { text: 'Analytics', to: { name: 'analytics' }, active: false },
            { text: 'Requests', active: true },
          ],
        },
      },
      {
        path: 'status-codes',
        component: () => import('@/views/cdn/dashboardV2/tabs/StatusCodes.vue'),
        name: 'status-codes',
        meta: {
          projectRequired: true,
          pageTitle: 'Analytics',
          parent: 'analytics',
          rule: 'admin',
          navActiveLink: 'analytics',
          redirectTo: 'analytics',
          noAnimation: true,
          breadcrumb: [
            { text: 'CDN', disabled: true },
            { text: 'Analytics', to: { name: 'analytics' }, active: false },
            { text: 'Status Codes', active: true },
          ],
        },
      },
    ],
  },
  {
    path: '/:projectId?/distributions',
    component: () => import('@/views/cdn/distributions/distribution/Distributions.vue'),
    name: 'distributions',
    meta: {
      projectRequired: true,
      pageTitle: 'Distributions',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', active: true },
      ],
      action: 'read',
      resource: 'project',
    },
  },
  {
    path: '/:projectId/distribution/:id',
    component: () => import('@/views/cdn/distributions/distribution/Distribution.vue'),
    name: 'distribution',
    noAnimation: true,
    children: [
      {
        path: 'settings',
        component: () => import('@/views/cdn/distributions/general/General.vue'),
        name: 'distribution-general',
        meta: {
          projectRequired: true,
          pageTitle: 'Distribution Settings',
          parent: 'distributions',
          rule: 'admin',
          breadcrumb: [
            { text: 'CDN', disabled: true },
            { text: 'Distributions', to: { name: 'distributions' } },
            { text: 'Distribution Settings', active: true },
          ],
          navActiveLink: 'distributions',
          redirectTo: 'distributions',
          noAnimation: true,
        },
      },
      {
        path: 'behaviors',
        component: () => import('@/views/cdn/distributions/behaviors/Behaviors.vue'),
        name: 'distribution-behaviors',
        meta: {
          projectRequired: true,
          pageTitle: 'Behaviors',
          parent: 'distributions',
          rule: 'admin',
          breadcrumb: [
            { text: 'CDN', disabled: true },
            { text: 'Distributions', to: { name: 'distributions' } },
            { text: 'Behaviors', active: true },
          ],
          navActiveLink: 'distributions',
          redirectTo: 'distributions',
          noAnimation: true,
        },
      },
      {
        path: 'origins',
        component: () => import('@/views/cdn/distributions/origins/Details.vue'),
        name: 'distribution-origins',
        meta: {
          projectRequired: true,
          pageTitle: 'Origin Settings',
          parent: 'distributions',
          rule: 'admin',
          breadcrumb: [
            { text: 'CDN', disabled: true },
            { text: 'Distributions', to: { name: 'distributions' } },
            { text: 'Origin and Origin Groups', active: true },
          ],
          navActiveLink: 'distributions',
          redirectTo: 'distributions',
          noAnimation: true,
        },
      },
      {
        path: 'error-pages',
        component: () => import('@/views/cdn/distributions/errors/ErrorPages.vue'),
        name: 'distribution-error-pages',
        meta: {
          projectRequired: true,
          pageTitle: 'Error Pages',
          parent: 'distributions',
          rule: 'admin',
          breadcrumb: [
            { text: 'CDN', disabled: true },
            { text: 'Distributions', to: { name: 'distributions' } },
            { text: 'Error Pages', active: true },
          ],
          navActiveLink: 'distributions',
          redirectTo: 'distributions',
          noAnimation: true,
        },
      },
      {
        path: 'restrictions',
        component: () => import('@/views/cdn/distributions/restrictions/Restrictions.vue'),
        name: 'distribution-restrictions',
        meta: {
          projectRequired: true,
          pageTitle: 'Restrictions',
          parent: 'distributions',
          rule: 'admin',
          breadcrumb: [
            { text: 'CDN', disabled: true },
            { text: 'Distributions', to: { name: 'distributions' } },
            { text: 'Restrictions', active: true },
          ],
          navActiveLink: 'distributions',
          redirectTo: 'distributions',
          noAnimation: true,
        },
      },
      {
        path: 'invalidations',
        component: () => import('@/views/cdn/distributions/invalidations/Invalidations.vue'),
        name: 'distribution-invalidations',
        meta: {
          projectRequired: true,
          pageTitle: 'Invalidations',
          parent: 'distributions',
          rule: 'admin',
          breadcrumb: [
            { text: 'CDN', disabled: true },
            { text: 'Distributions', to: { name: 'distributions' } },
            { text: 'Invalidations', active: true },
          ],
          navActiveLink: 'distributions',
          redirectTo: 'distributions',
          noAnimation: true,
        },
      },
      {
        path: 'tags',
        component: () => import('@/views/cdn/distributions/tags/Tags.vue'),
        name: 'distribution-tags',
        meta: {
          projectRequired: true,
          pageTitle: 'Tags',
          parent: 'distributions',
          rule: 'admin',
          breadcrumb: [
            { text: 'CDN', disabled: true },
            { text: 'Distributions', to: { name: 'distributions' } },
            { text: 'Tags', active: true },
          ],
          navActiveLink: 'distributions',
          redirectTo: 'distributions',
          noAnimation: true,
        },
      },
    ],
  },
  {
    path: '/:projectId/distribution-behaviors/:id/create',
    component: () => import('@/views/cdn/distributions/behaviors/Create.vue'),
    name: 'distribution-behaviors-create',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Create Behavior',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Behaviors', route: 'distribution-behaviors' },
        { text: 'Create Behavior', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/distribution-behaviors/:id/edit/:behaviorId',
    component: () => import('@/views/cdn/distributions/behaviors/Edit.vue'),
    name: 'distribution-behaviors-edit',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Edit Behavior',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Behaviors', route: 'distribution-behaviors' },
        { text: 'Edit Behavior', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/distribution-origins/:id/create',
    component: () => import('@/views/cdn/distributions/origins/origin/Create.vue'),
    name: 'distribution-origins-create',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Create Origin',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Origin and Origin Groups', route: 'distribution-origins' },
        { text: 'Create Origin', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/distribution-origins/:id/edit/:originId',
    component: () => import('@/views/cdn/distributions/origins/origin/Edit.vue'),
    name: 'distribution-origins-edit',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Edit Origin',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Origin and Origin Groups', route: 'distribution-origins' },
        { text: 'Edit Origin', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/distribution-healthchecks/:id/create',
    component: () => import('@/views/cdn/distributions/origins/healthcheck/Create.vue'),
    name: 'distribution-healthchecks-create',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Create Healthcheck',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Origin and Origin Groups', route: 'distribution-origins' },
        { text: 'Create Healthcheck', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/distribution-healthchecks/:id/edit/:healthcheckId',
    component: () => import('@/views/cdn/distributions/origins/healthcheck/Edit.vue'),
    name: 'distribution-healthchecks-edit',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Edit Healthcheck',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Origin and Origin Groups', route: 'distribution-origins' },
        { text: 'Edit Healthcheck', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/distribution-origin-groups/:id/create',
    component: () => import('@/views/cdn/distributions/origins/groups/Create.vue'),
    name: 'distribution-origin-groups-create',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Create Origin Group',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Origin and Origin Groups', route: 'distribution-origins' },
        { text: 'Create Origin Group', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/distribution-origin-groups/:id/edit/:origingroupId',
    component: () => import('@/views/cdn/distributions/origins/groups/Edit.vue'),
    name: 'distribution-origin-groups-edit',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Edit Origin Group',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Origin and Origin Groups', route: 'distribution-origins' },
        { text: 'Edit Origin Group', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/distribution-error-pages/:id/create',
    component: () => import('@/views/cdn/distributions/errors/Create.vue'),
    name: 'distribution-error-pages-create',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Create Error Page',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Error Pages', route: 'distribution-error-pages' },
        { text: 'Create Error Pages', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/distribution-error-pages/:id/edit/:errorpageId',
    component: () => import('@/views/cdn/distributions/errors/Edit.vue'),
    name: 'distribution-error-pages-edit',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Edit Error Page',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Error Pages', route: 'distribution-error-pages' },
        { text: 'Edit Error Pages', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/distribution-tags/:id/edit',
    component: () => import('@/views/cdn/distributions/tags/TagsForm.vue'),
    name: 'distribution-tags-edit',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Tags',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Tags', route: 'distribution-tags' },
        { text: 'Edit Tags', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/distribution-settings/:id/edit',
    component: () => import('@/views/cdn/distributions/general/Editor.vue'),
    name: 'settings-editor',
    meta: {
      ignoreCaseForId: true,
      projectRequired: true,
      pageTitle: 'Edit Distribution Settings',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Distributions Settings', route: 'distribution-general' },
        { text: 'Edit Distribution Settings', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/create-distribution',
    component: () => import('@/views/cdn/distributions/distribution/DistributionNew.vue'),
    name: 'create-distribution',
    meta: {
      projectRequired: true,
      pageTitle: 'Distributions',
      parent: 'distributions',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Distributions', to: { name: 'distributions' } },
        { text: 'Create Distribution', active: true },
      ],
      navActiveLink: 'distributions',
      redirectTo: 'distributions',
    },
  },
  {
    path: '/:projectId/policies',
    component: () => import('@/views/cdn/policies/Policies.vue'),
    meta: {
      projectRequired: true,
      pageTitle: 'Policies',
      rule: 'admin',
      breadcrumb: [{ text: 'CDN', disabled: true }, { text: 'Policies' }],
      navActiveLink: 'cache-policies',
    },
    children: [
      {
        path: 'origin-request',
        component: () => import('@/views/cdn/policies/request/RequestPolicies.vue'),
        name: 'request-policies',
        meta: {
          projectRequired: true,
          pageTitle: 'Policies',
          rule: 'admin',
          breadcrumb: [{ text: 'CDN', disabled: true }, { text: 'Policies' }],
          navActiveLink: 'cache-policies',
          noAnimation: true,
        },
      },
      {
        path: 'cache',
        component: () => import('@/views/cdn/policies/cache/CachePolicies.vue'),
        name: 'cache-policies',
        meta: {
          projectRequired: true,
          pageTitle: 'Policies',
          rule: 'admin',
          breadcrumb: [{ text: 'CDN', disabled: true }, { text: 'Policies' }],
          navActiveLink: 'cache-policies',
          noAnimation: true,
        },
      },
      {
        path: 'image',
        component: () => import('@/views/cdn/policies/image/ImagePolicies.vue'),
        name: 'image-policies',
        meta: {
          projectRequired: true,
          pageTitle: 'Policies',
          rule: 'admin',
          breadcrumb: [{ text: 'CDN', disabled: true }, { text: 'Policies' }],
          navActiveLink: 'image-policies',
          noAnimation: true,
        },
      },
    ],
  },
  {
    path: '/:projectId/cache-policy/:cacheId/info',
    component: () => import('@/views/cdn/policies/cache/CachePoliciesInfo.vue'),
    name: 'cache-policy-info',
    meta: {
      projectRequired: true,
      pageTitle: 'Cache Policy Info',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Cache Policies', to: { name: 'cache-policies' } },
        { text: 'Info', active: true },
      ],
      navActiveLink: 'cache-policies',
      redirectTo: 'cache-policies',
    },
  },
  {
    path: '/:projectId/cache-policy/:cacheId/edit',
    component: () => import('@/views/cdn/policies/cache/Edit.vue'),
    name: 'cache-policy-edit',
    meta: {
      projectRequired: true,
      pageTitle: 'Edit Cache Policy',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Cache Policies', to: { name: 'cache-policies' } },
        { text: 'Edit', active: true },
      ],
      navActiveLink: 'cache-policies',
      redirectTo: 'cache-policies',
    },
  },
  {
    path: '/:projectId/cache-policy/create',
    component: () => import('@/views/cdn/policies/cache/Create.vue'),
    name: 'cache-policy-create',
    meta: {
      projectRequired: true,
      pageTitle: 'Create Cache Policy',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Cache Policies', to: { name: 'cache-policies' } },
        { text: 'Create', active: true },
      ],
      navActiveLink: 'cache-policies',
      redirectTo: 'cache-policies',
    },
  },
  {
    path: '/:projectId/request-policy/:requestId/info',
    component: () => import('@/views/cdn/policies/request/RequestPoliciesInfo.vue'),
    name: 'request-policy-info',
    meta: {
      projectRequired: true,
      pageTitle: 'Request Policy Info',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Request Policies', to: { name: 'request-policies' } },
        { text: 'Info', active: true },
      ],
      navActiveLink: 'cache-policies',
      redirectTo: 'cache-policies',
    },
  },
  {
    path: '/:projectId/request-policy/:requestId/edit',
    component: () => import('@/views/cdn/policies/request/Edit.vue'),
    name: 'request-policy-edit',
    meta: {
      projectRequired: true,
      pageTitle: 'Edit Request Policy',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Request policies', to: { name: 'request-policies' } },
        { text: 'Edit', active: true },
      ],
      navActiveLink: 'cache-policies',
      redirectTo: 'cache-policies',
    },
  },
  {
    path: '/:projectId/image-policy/create',
    component: () => import('@/views/cdn/policies/image/Create.vue'),
    name: 'image-policy-create',
    meta: {
      projectRequired: true,
      pageTitle: 'Create Image Policy',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Image Policies', to: { name: 'image-policies' } },
        { text: 'Create', active: true },
      ],
      navActiveLink: 'image-policies',
      redirectTo: 'image-policies',
    },
  },
  {
    path: '/:projectId/image-policy/:imageId/edit',
    component: () => import('@/views/cdn/policies/image/Edit.vue'),
    name: 'image-policy-edit',
    meta: {
      projectRequired: true,
      pageTitle: 'Edit Image Policy',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Image Policies', to: { name: 'image-policies' } },
        { text: 'Edit', active: true },
      ],
      navActiveLink: 'image-policies',
      redirectTo: 'image-policies',
    },
  },
  {
    path: '/:projectId/image-policy/:imageId/info',
    component: () => import('@/views/cdn/policies/image/ImagePoliciesInfo.vue'),
    name: 'image-policy-info',
    meta: {
      projectRequired: true,
      pageTitle: 'Image Policy Info',
      rule: 'admin',
      breadcrumb: [
        { text: 'CDN', disabled: true },
        { text: 'Image Policies', to: { name: 'image-policies' } },
        { text: 'Info', active: true },
      ],
      navActiveLink: 'image-policies',
      redirectTo: 'image-policies',
    },
  },
  // {
  //   path: '/:projectId/request-policy/create',
  //   component: () => import('@/views/cdn/policies/request/Create.vue'),
  //   name: 'request-policy-create',
  //   meta: {
  //     projectRequired: true,
  //     pageTitle: 'Create Request Policy',
  //     rule: 'admin',
  //     breadcrumb: [
  //       { text: 'CDN', disabled: true },
  //       { text: 'Request policies', to: { name: 'request-policies' } },
  //       { text: 'Create', active: true },
  //     ],
  //     navActiveLink: 'cache-policies',
  //     redirectTo: 'cache-policies',
  //   },
  // },
]
